import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StepComponentProps } from "@/components/organisms";
import { StyledWizardSubtitle } from "@/components/organisms/Forms/Wizard/WizardForm/styled";
import { StyledHeaderTitleBase } from "@/styles/components";

const IntroStep: FC<StepComponentProps> = () => {
    const { t } = useTranslation();
    return (
        <>
            <StyledHeaderTitleBase>{t("Common.Introduction")}</StyledHeaderTitleBase>
            <StyledWizardSubtitle style={{ margin: "16px 0" }}>
                {t("DataVerification.Company.Introduction")}
            </StyledWizardSubtitle>
        </>
    );
};

export default IntroStep;
